import { render, staticRenderFns } from "./DocumentsUploadFileModal.vue?vue&type=template&id=15b1d8fe&"
import script from "./DocumentsUploadFileModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsUploadFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports